export async function requestAIStoryInsightCandidates({
  endpoint,
  events,
  maxBandTimeSpan,
  maxBandOrderSpan,
  matchId,
  storyContext,
  toInsightLLMEvent,
  validateAIInsightResponse,
  cleanDraftText,
  createTimeoutSignal,
  fetchRef = fetch,
}) {
  if (!endpoint) throw new Error('No LLM endpoint configured')
  const timeout = createTimeoutSignal(480000)
  try {
    const response = await fetchRef(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: timeout.signal,
      body: JSON.stringify({
        task: 'story-insights',
        promptVersion: 'story-insight-v1',
        matchId,
        maxCandidates: 6,
        maxEvidenceEvents: 8,
        maxBandTimeSpan,
        maxBandOrderSpan,
        storyContext,
        refreshNonce: String(Date.now()),
        events: events.map(toInsightLLMEvent),
      }),
    })
    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(
        `LLM endpoint returned ${response.status}${
          errorText ? `: ${cleanDraftText(errorText, 180)}` : ''
        }`
      )
    }
    const rawResponse = await response.json()
    return {
      candidates: validateAIInsightResponse(rawResponse, events),
      model: cleanDraftText(rawResponse.model, 80) || 'external',
      datasetNotes: cleanDraftText(rawResponse.datasetNotes, 240),
    }
  } finally {
    if (timeout.cancel) timeout.cancel()
  }
}
